import React, { useState, useEffect } from 'react';
import './Carousel.css';

const Carousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [imageErrors, setImageErrors] = useState({});

  // Updated carousel data with corrected image paths and fallback
  const carouselData = {
    images: [
      {
        src: '/assets/images/c2.png', // Removed /public from path
        fallback: 'https://via.placeholder.com/1920x1080/1a1a1a/ffffff?text=Transforming+Digital+Enterprise',
        title: 'Finance & Accounting',
        subtitle: 'A Digital Enterprise',
        description: 'Learn More About Us'
      },
      {
        src: '/assets/images/c1.png',
        fallback: 'https://via.placeholder.com/1920x1080/2a2a2a/ffffff?text=Our+Company+Innovation',
        title: 'Market Entry & Incorporation',
        subtitle: 'Leading Innovation',
        description: 'Discover Our Solutions'
      },
      {
        src: '/assets/images/c3.png',
        fallback: 'https://via.placeholder.com/1920x1080/3a3a3a/ffffff?text=Cyber+Security+Protection',
        title: 'Human Resources & Payroll',
        subtitle: 'Protection First',
        description: 'Secure Your Future'
      },
      {
        src: '/assets/images/c4.png',
        fallback: 'https://via.placeholder.com/1920x1080/4a4a4a/ffffff?text=Industry+Insights+Analytics',
        title: 'Industry Insights',
        subtitle: 'Intellectual Property & Cyber Law',
        description: 'Explore Our Analytics'
      }
    ]
  };

  const totalSlides = carouselData.images.length;

  // Handle image load errors
  const handleImageError = (index) => {
    setImageErrors(prev => ({ ...prev, [index]: true }));
  };

  // Auto-play functionality
  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % totalSlides);
    }, 4000);

    return () => clearInterval(interval);
  }, [isAutoPlaying, totalSlides]);

  // Navigation functions
  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
  };

  // Pause auto-play on hover
  const handleMouseEnter = () => {
    setIsAutoPlaying(false);
  };

  const handleMouseLeave = () => {
    setIsAutoPlaying(true);
  };

  return (
    <div 
      className="carousel-container"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="carousel-wrapper">
        <div 
          className="carousel-slides"
          style={{ transform: `translateX(-${currentSlide * 25}%)` }}
        >
          {carouselData.images.map((slide, index) => (
            <div key={index} className="carousel-slide">
              <div className="carousel-image-container">
                <img 
                  src={imageErrors[index] ? slide.fallback : slide.src}
                  alt={`${slide.title} - ${slide.subtitle}`}
                  className="carousel-image"
                  onError={() => handleImageError(index)}
                  onLoad={() => console.log(`Image ${index + 1} loaded successfully`)}
                />
                <div className="carousel-overlay"></div>
              </div>
              <div className="carousel-content">
                <h2 className="carousel-title">{slide.title}</h2>
                <h1 className="carousel-subtitle">{slide.subtitle}</h1>
                <button className="carousel-cta">
                  {slide.description}
                  <span className="carousel-arrow">→</span>
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation Arrows */}
        <button 
          className="carousel-nav carousel-nav-prev" 
          onClick={prevSlide}
          aria-label="Previous slide"
        >
          <span>‹</span>
        </button>
        <button 
          className="carousel-nav carousel-nav-next" 
          onClick={nextSlide}
          aria-label="Next slide"
        >
          <span>›</span>
        </button>

        {/* Dots Indicator */}
        <div className="carousel-dots">
          {carouselData.images.map((_, index) => (
            <button
              key={index}
              className={`carousel-dot ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            >
              <span className="dot-line"></span>
            </button>
          ))}
        </div>

        {/* Progress Bar */}
        <div className="carousel-progress">
          <div 
            className="carousel-progress-bar"
            style={{ 
              width: `${((currentSlide + 1) / totalSlides) * 100}%`,
              animationDuration: isAutoPlaying ? '4s' : 'none'
            }}
          ></div>
        </div>
      </div>

      {/* Section Navigation */}
      <div className="section-navigation">
        <div className={`section-nav-item ${currentSlide === 0 ? 'active' : ''}`}>
          <span className="section-number">-</span>
          <span className="section-title">Finance & Accounting</span>
        </div>
        <div className={`section-nav-item ${currentSlide === 1 ? 'active' : ''}`}>
          <span className="section-number">-</span>
          <span className="section-title">Market Entry & Incorporation</span>
        </div>
        <div className={`section-nav-item ${currentSlide === 2 ? 'active' : ''}`}>
          <span className="section-number">-</span>
          <span className="section-title">Human Resources & Payroll</span>
        </div>
        <div className={`section-nav-item ${currentSlide === 3 ? 'active' : ''}`}>
          <span className="section-number">-</span>
          <span className="section-title">Intellectual Property & Cyber Law</span>
        </div>
      </div>
    </div>
  );
};

export default Carousel;